import React from 'react';
import './Registration.css';

const MathsHubAbout = () => {
  return (
    <div className="reg-container">

      {/* Registration Section */}
      <section className="reg-main-section">
        <div className="reg-content-wrapper">
          <div className="reg-letter-header">
            <p className="reg-greeting">Dear Parents and Guardians,</p>
            <p className="reg-intro-text">
              We are excited to welcome new and returning students to our learning community for the 
              <strong> 2026 Academic Year</strong>. Registration is now open, and we invite you to secure your 
              child's place in our enriching and academically focused programs.
            </p>
          </div>

          <div className="reg-principal-info">
            <p>
              Our institute is led by <strong>Mr Sahan Fernando</strong>, our Principal Tutor, who brings a 
              wealth of experience and academic excellence to every classroom. Mr Fernando is a registered 
              Victorian Teacher and Learning Advisor, with the following qualifications:
            </p>
            <ul className="reg-qualifications-list">
              <li>Master of Information Technology – Deakin University</li>
              <li>Master of Teaching (Secondary) – Federation University</li>
              <li>Postgraduate Mathematics (Distinction) – Charles Sturt University</li>
              <li>Commencing Research Studies – Charles Sturt University (2026)</li>
            </ul>
            <p>
              With this strong foundation, Mr Fernando ensures that every student receives high-quality 
              instruction tailored to their academic goals.
            </p>
          </div>

          <div className="reg-why-choose">
            <h2>Why Choose Us?</h2>
            <ul className="reg-benefits-list">
              <li>Expert-led classes with a focus on academic excellence</li>
              <li>Personalised support for scholarship and selective entrance preparation</li>
              <li>Proven success in VCE subjects and foundational year levels</li>
              <li>A nurturing environment that builds confidence and capability</li>
            </ul>
          </div>

          <div className="reg-schedule-section">
            <h2>2026 Class Schedule</h2>
            <div className="reg-table-container">
              <table className="reg-schedule-table">
                <thead>
                  <tr>
                    <th>Program</th>
                    <th>Day & Time</th>
                    <th>Location</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Grade 8</td>
                    <td>Wednesday 6:45–8:15pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Junior Scholarship</td>
                    <td>Saturday 1:15–2:15pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Selective Entrance</td>
                    <td>Saturday 6:15–7:15pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>VCE General Maths 1&2</td>
                    <td>Thursday 7:15–8:45pm</td>
                    <td>Mt Waverly</td>
                  </tr>
                  <tr>
                    <td>VCE General Maths 1&2</td>
                    <td>Monday 6:45–8:15pm</td>
                    <td>Narre Warren</td>
                  </tr>
                  <tr>
                    <td>VCE General Maths 3/4</td>
                    <td>Sunday 1:20–2:30pm</td>
                    <td>Narre Warren</td>
                  </tr>
                  <tr>
                    <td>VCE Methods 1&2</td>
                    <td>Friday 6:45–8:15pm</td>
                    <td>Narre Warren</td>
                  </tr>
                  <tr>
                    <td>VCE Methods 3/4</td>
                    <td>Wednesday 5:15–6:45pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Year 1</td>
                    <td>Saturday 11:00–12:00 noon</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Year 2 & Year 3</td>
                    <td>Saturday 3:30–4:30pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Year 4</td>
                    <td>Saturday 12:00–1:15pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Year 5</td>
                    <td>Saturday 2:15–3:30pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Year 6</td>
                    <td>Monday 5:15–6:45pm</td>
                    <td>—</td>
                  </tr>
                  <tr>
                    <td>Year 7</td>
                    <td>Friday 5:15–6:45pm</td>
                    <td>Narre Warren</td>
                  </tr>
                  <tr>
                    <td>Year 7</td>
                    <td>Thursday 5:45–7:15pm</td>
                    <td>Mt Waverly</td>
                  </tr>
                  <tr>
                    <td>Year 8</td>
                    <td>Sunday 4:45–6:15pm</td>
                    <td>Narre Warren</td>
                  </tr>
                  <tr>
                    <td>Year 9</td>
                    <td>Sunday 9:15–10:45am</td>
                    <td>Mt Waverly</td>
                  </tr>
                  <tr>
                    <td>Year 9</td>
                    <td>Sunday 4:00–5:30pm</td>
                    <td>Narre Warren / Mt Waverly</td>
                  </tr>
                  <tr>
                    <td>Year 10</td>
                    <td>Sunday 2:30–4:00pm</td>
                    <td>Narre Warren</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="reg-cta-box"> 
            <p className="reg-term2-note">
              We kindly ask that you complete this form for <strong>Term 2 enrolment</strong>. 
              For families with multiple children, please submit a separate response for each child.
            </p>
            <a 
              href="https://forms.gle/Bfkxg5TPTt26ap3Y9" 
              className="reg-link-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              👉 Register Here
            </a>
            <p className="reg-closing-text">
              We look forward to supporting your child's academic journey and helping them thrive in 2026 and beyond.
            </p>
            <p className="reg-signature">
              <strong>Warm regards,</strong><br />
              Team Mathshub
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MathsHubAbout;